var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.navList),function(item,index){return _c('li',{key:index,class:[
      _vm.idx === index ? 'sunshine-active' : '',
      index === 0 ? 'home' : 'item-li'
    ],on:{"click":function($event){return _vm.goUrl(item, index)}}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49ceece5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/children/BToB/common/menuComBToB.vue
// module id = null
// module chunks = 